import React from 'react';
import { Box } from '@/shared/ui/box';
import { Image } from '@/shared/ui/image';
import {
  BodyTextRegularSecondary,
  BodyTextBoldPrimary,
  BodyTextBoldSecondary,
} from '@/shared/ui/typography';

import { useAuthorization } from '@/entities/session';

import { useAuth } from '@/features/auth-managment/model/auth-context';
import {
  FormWrapper,
  SpinnerBox,
  CircleBorder,
  CircleCore,
  CircleImage,
  ConfirmationPhoneText,
  AuthCloseIconImage,
  FormContainer,
  ButtonContinue,
} from '@/features/auth-managment/styles';

export const ConfirmPasswordEmail = () => {
  const {
    handleClose,
    t,
    currentStep,
    setCurrentStep,
    setAuthenticationType,
    form,
  } = useAuth();

  const { resendRecoveryEmail } = useAuthorization();

  return (
    <FormWrapper $currentStep={currentStep}>
      <FormContainer>
        <Box onClick={handleClose}>
          <AuthCloseIconImage
            width={32}
            height={32}
            src="/images/icons/close-dialog.svg"
          />
        </Box>

        <SpinnerBox>
          <CircleBorder>
            <CircleCore />
          </CircleBorder>
          <CircleImage
            width={56}
            height={56}
            src={'/images/background/email-spin.svg'}
          />
        </SpinnerBox>
        <Box $paddingTop={16} $textAlign="center">
          <BodyTextBoldPrimary>{t('auth.reset.title')}</BodyTextBoldPrimary>
        </Box>
        <Box $paddingTop={8} $paddingBottom={16} $textAlign="center">
          <BodyTextRegularSecondary color="#AFAFAF">
            {t('auth.reset.sent')}
          </BodyTextRegularSecondary>
        </Box>
        <ConfirmationPhoneText>
          <BodyTextBoldPrimary>{form.email}</BodyTextBoldPrimary>
          <span onClick={() => setCurrentStep('reset-password-email')}>
            <Image src="/images/icons/pencil.svg" width={20} height={20} />
          </span>
        </ConfirmationPhoneText>
        <Box>
          <ButtonContinue
            onClick={() => resendRecoveryEmail(form)}
            type="button"
          >
            <BodyTextBoldSecondary>
              {t('auth.email.resend')}
            </BodyTextBoldSecondary>
          </ButtonContinue>
        </Box>
        <Box $paddingTop={12}>
          <ButtonContinue
            onClick={() => {
              setCurrentStep('authorization');
              setAuthenticationType('signin');
            }}
            type="button"
            variant="secondary"
          >
            <BodyTextBoldSecondary>
              {t('auth.reset.back')}
            </BodyTextBoldSecondary>
          </ButtonContinue>
        </Box>
      </FormContainer>
    </FormWrapper>
  );
};
